export default __webpack_public_path__ + "images/PRJ.acf7f11.png";